<div class="d-flex align-items-center flex-column">
  <h1 class="title mb-1">
    {{ "DATA.TITLES.WELCOME_TO" | translate }}
  </h1>
  <p class="subtitle">
    {{ "DATA.TITLES.SIGN_TO" | translate }}
  </p>
</div>

<!-- Login Form -->
<login-form [isLoading]="isLoading" (onSubmit)="login($event)"></login-form>
<p class="text-center mt-1 font-small-2">
  <span>{{ "DATA.LABELS.NEW_FOODER" | translate }}</span>
  <!-- Redirect according to is WhatsApp Form or Fooder -->
  <a [routerLink]="['/onboarding']">
    <span>&nbsp;{{ "DATA.LABELS.SIGN_UP" | translate }}</span>
  </a>
</p>
